import constants from './constants'
import base from '../api/base'

const { headers, url, request } = base

const isEnabled = () => process.env.REACT_APP_RECAPTCHA_ENABLED !== 'false'

const isValid = async token => {
    const body = JSON.stringify({ token })

    return request(url(constants.api.publicCall.validateRecaptcha), {
        method: 'POST',
        headers: headers(),
        body,
    })
}

const recaptcha = { isEnabled, isValid }
export default recaptcha